var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 1.25H1.25V9.0625H11.5172C14.0447 9.0625 16.0938 11.1115 16.0938 13.6391V42.6562H23.9062V13.6391C23.9062 11.1115 25.9553 9.0625 28.4828 9.0625H38.75V1.25Z",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 97.3438H1.25V55.9375H38.75V63.75H13.6391C11.1115 63.75 9.0625 65.799 9.0625 68.3266V97.3438Z",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5012 63.75H13.768C11.2404 63.75 9.19141 65.799 9.19141 68.3266V97.3438H77.9246V68.3266C77.9246 65.799 79.9736 63.75 82.5012 63.75Z",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3438 1.25H38.75V9.0625H97.3438V1.25Z",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8359 55.9375H97.3438V63.75H38.75V55.9375H59.2578",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0766 9.0625H28.4828C25.9553 9.0625 23.9062 11.1115 23.9062 13.6391V42.6562H82.5V13.6391C82.5 11.1115 84.549 9.0625 87.0766 9.0625Z",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.0469,
    cy: 55.9375,
    r: 1.95312,
    fill: "#012060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeil);
export default __webpack_public_path__ + "static/media/ceil.38bf7d4b93c4a3630c65d4ae99039c9b.svg";
export { ForwardRef as ReactComponent };